exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-next[data-v-4a1bbb96]{position:absolute;bottom:10px;right:10px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(1.5px 1.5px 1px #222);filter:drop-shadow(1.5px 1.5px 1px #222)}.button-next.disabled[data-v-4a1bbb96]{display:none;pointer-events:none}.button-title[data-v-4a1bbb96]{font-family:Nunito;position:absolute;bottom:4px;right:26px;z-index:999;font-size:13px;text-decoration:none;color:#000}@media only screen and (max-width:750px){.button-next[data-v-4a1bbb96]{bottom:5px;right:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4a1bbb96","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonNext.vue
// module id = 85
// module chunks = 0